import React from 'react';
import Header from '../Components/Header/Header';
import Main from '../Components/Main/Main';


function Home() {
  return (
    <div className="app">
      <Header />
      <Main />
    </div>
  );
}

export default Home;
